import { ExpeditionsActions } from "./actions";
import { ExpeditionsConnection } from "./actions/connection";
import { ExpeditionsQueue } from "./queue";
import { ExpeditionsShipmentModal } from "./Shipment";

export const Expeditions = {
  queue: ExpeditionsQueue,
  actions: ExpeditionsActions,
  connection: ExpeditionsConnection,
  shipment: ExpeditionsShipmentModal
} as const;
